import axios from 'axios';
import {setTokens} from './setTokens';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';
import {actions as A} from '../constants/actions';

export const refreshToken = accessToken => async dispatch => {
  dispatch({
    type: A.REFRESH_TOKEN,
  });

  const response = await axios.post(api.REFRESH_TOKEN, {}, {
    headers: {accessToken}
  })
  const {errorCode, body} = response.data;
  if (errorCode < 0) {
    throw new Error(E.SERVER_ERROR)
  } else {
    const {accessToken, expireTime: expire} = body.newTokenData;
    setTokens({
      accessToken,
      expire,
      receivedAt: new Date(response.data.header.response_server_time)
    })(dispatch);

    return accessToken;
  }
};
